import { ImagePicture } from 'approot/shared/images/images';

import contentSchoolAvif from './content-school.avif';
import contentSchoolWebp from './content-school.webp';
import contentSchoolPng from './content-school.png';

const ImageContentSchool = ({ width }: { width?: number }) => (
  <ImagePicture
    lazyLoad
    style={width ? { width } : undefined}
    avif={{ path: contentSchoolAvif }}
    webp={{ path: contentSchoolWebp }}
    png={{ path: contentSchoolPng }}
  />
);

export default ImageContentSchool;
